module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['m-agenda-item']
  }, [_c('div', {
    staticClass: "item-wrap",
    class: {
      'item-wrap-small': _vm.data.speaker.length == 0
    }
  }, [(_vm.index == 0) ? _c('h2', {
    staticClass: "item-wrap-title-bg"
  }, [_vm._v(_vm._s(_vm.type.split('|')[0].substr(2, 10)))]) : _vm._e(), _vm._v(" "), (_vm.data.time.split('|')[1]) ? _c('h2', {
    staticClass: "item-wrap-title"
  }, [_vm._v(_vm._s(_vm.data.time.split('|')[1]))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "a-content"
  }, [_c('div', {
    staticClass: "a-content-wrap"
  }, [(false && _vm.data.speaker[0] && _vm.data.speaker[0].photo) ? _c('div', {
    staticClass: "left"
  }, [(false) ? _c('div', {
    staticClass: "name-title"
  }, [_c('div', {
    staticClass: "photo"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.speaker[0].photo
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('p', {
    staticClass: "t-name"
  }, [_vm._v(" " + _vm._s(_vm.data.time.split('|')[0]) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "subject-type"
  }, [_vm._v(_vm._s(_vm.data.subject.split('|')[0]))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "subject-title",
    domProps: {
      "innerHTML": _vm._s(_vm.data.subject.split('|')[1])
    }
  }), _vm._v(" "), (_vm.data.speaker.length) ? _c('div', {
    staticClass: "speaker"
  }, [_c('div', {
    staticClass: "speaker-title"
  }, [_vm._v("主持人：")]), _vm._v(" "), _c('div', {
    staticClass: "speaker-content"
  }, _vm._l((_vm.data.speaker), function(user) {
    return _c('p', [_vm._v(" " + _vm._s(user.name) + "　" + _vm._s(user.position))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.data.guest.length) ? _c('div', {
    staticClass: "speaker"
  }, [_c('div', {
    staticClass: "speaker-title"
  }, [_vm._v("嘉　宾：")]), _vm._v(" "), _c('div', {
    staticClass: "speaker-content"
  }, _vm._l((_vm.data.guest), function(user) {
    return _c('p', [_vm._v(" " + _vm._s(user.name) + "　" + _vm._s(user.position))])
  }), 0)]) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-327dcde6"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileAgendaItem.vue
// module id = 30
// module chunks = 0